import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import { AdminProviderSearchScreen } from "~/screens/AdminProviderSearchScreen";
import AdminProviderSelectionScreen from "~/screens/AdminProviderSelectionScreen";
import { AdminSignUpScreen } from "~/screens/AdminSignUpScreen";
import { FailedEligibilityCheckScreen } from "~/screens/FailedEligibilityCheckScreen";
import { PendingEligibilityCheckScreen } from "~/screens/PendingEligibilityCheckScreen";
import ProviderSelectionScreen from "~/screens/ProviderSelectionScreen";
import { SignUp } from "~/screens/SignUp";
import { EligibilitySuccessScreen } from "~/screens/SuccessEligibilityCheckScreen";
import { TestPixelScreen } from "~/screens/TestPixelScreen";
import { ProtectedAdminRoute } from "./components/ProtectedAdminRoute";
import { ProtectedOnboardingRoute } from "./components/ProtectedOnboardingRoute";
import { ROUTES } from "./routes";

export const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="*" element={<Navigate to={ROUTES.signUp} />} />
        <Route path={ROUTES.signUp} element={<SignUp />} />
        <Route path={ROUTES.testPixel} element={<TestPixelScreen />} />
        <Route
          path={ROUTES.adminProviderSearch}
          element={<AdminProviderSearchScreen />}
        />
        <Route path={ROUTES.adminSignUp} element={<AdminSignUpScreen />} />
        <Route element={<ProtectedAdminRoute />}>
          <Route
            path={ROUTES.adminProviderSelection}
            element={<AdminProviderSelectionScreen />}
          />
        </Route>
        <Route element={<ProtectedOnboardingRoute />}>
          <Route
            path={ROUTES.providerSelection}
            element={<ProviderSelectionScreen />}
          />
          <Route
            path={ROUTES.eligibilityCheck.successEligibilityCheck}
            element={<EligibilitySuccessScreen />}
          />
          <Route
            path={ROUTES.eligibilityCheck.failedEligibilityCheck}
            element={<FailedEligibilityCheckScreen />}
          />
          <Route
            path={ROUTES.eligibilityCheck.pendingEligibilityCheck}
            element={<PendingEligibilityCheckScreen />}
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};
